import { joursRetard } from './dates';

/**
 * Premier rappel d'une facture en retard.
 *
 * L'application n'expédie rien seule : elle prépare le rappel, et l'artisan
 * l'envoie. La préparation elle-même n'est donc pas anodine — elle inscrit sur
 * la facture qu'un rappel a été établi, à une date donnée. Si personne ne
 * l'envoie, le dossier dit le contraire de ce que le client a reçu, et le
 * deuxième rappel part comme s'il y en avait eu un premier.
 *
 * C'est pourquoi cette préparation se demande et ne s'impose pas.
 */

/** Dit si l'entreprise a demandé la préparation automatique. */
export function rappelAutoDemande(soc) {
  return soc?.rappelAuto === true;
}

/**
 * Dit si une facture appelle un premier rappel.
 *
 * Seules les factures parties et non soldées sont concernées, et une seule
 * fois : une facture déjà relancée ne se relance pas à chaque ouverture de
 * l'application.
 *
 * @param {object} f facture
 * @returns {boolean}
 */
export function appellePremierRappel(f) {
  if (!f) {
    return false;
  }
  const enCours = f.statut === 'Envoyée' || f.statut === 'Partielle';
  const jamaisRelancee = !f.rappelAutoLe && (f.rappelNiveau || 0) === 0;
  return enCours && jamaisRelancee && joursRetard(f) > 0;
}
